module.exports = __webpack_public_path__ + "img/CHS_play_game_button.fce1ad4c.png";